import { FC } from "react";
import { useLayoutContext } from '../../../PageLayout/context/LayoutContext';
import { ProImage } from '../../../antd';
import classNames from "classnames";
import { filterEmptyValue } from "../../../utils/utils";
import { renderEnumName } from '../../../utils/renderUtils'
import { ScanPageRightItemEnum, ScanPageRightGoodInfoProps } from "../../interface";

const GoodInfo: FC<ScanPageRightGoodInfoProps> = props => {
  const { className, style, imagePath, options, } = props;
  const { enumData } = useLayoutContext();
  const classes = classNames('body-right-good-info', className);
  return (
    <div className={classes} style={style}>
      <div className="good-info-image-wrapper">
        <ProImage className="good-info-image" src={imagePath} />
      </div>
      <div className="good-info-items">
        {
          options?.map(option => {
            const { label, value, className, style, enumName, } = option;
            const itemClasses = classNames('good-info-item', className)
            return (
              <div key={value} className={itemClasses} style={style}>
                {!!label && <div className="item-label">{label}:</div>}
                <div className="item-text">
                  {enumName ? renderEnumName(value as string, enumData?.[enumName]?.items ?? []) : filterEmptyValue(value)}
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

GoodInfo.displayName = ScanPageRightItemEnum.RightGoodInfo;

export default GoodInfo;